import { useState } from 'react';
import { reviews } from '@/mocks/articles';

export default function ReviewsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const current = reviews[activeIndex];

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[38%] w-full">
            <div className="rounded-2xl overflow-hidden aspect-[3/4] max-w-sm mx-auto lg:max-w-none bg-accent-100">
              <img
                src={current.avatar}
                alt={current.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[62%]">
            <span className="text-xs tracking-widest uppercase text-foreground-400 font-medium mb-3 block">
              ( 用户口碑 )
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-2">
              数百万吃瓜群众
            </h2>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-300/60 leading-tight mb-8">
              的<span className="text-foreground-950">真实评价</span>
            </h2>

            <blockquote className="mb-8">
              <p className="text-lg md:text-xl text-foreground-700 leading-relaxed">
                &ldquo;{current.content}&rdquo;
              </p>
            </blockquote>

            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-semibold text-foreground-950">
                  &mdash; {current.name}
                </p>
                <p className="text-xs text-foreground-500 mt-0.5">{current.date}</p>
                <div className="flex items-center gap-0.5 mt-2">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`text-sm ${i < current.rating ? 'ri-star-fill text-secondary-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
              </div>

              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={handlePrev}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:text-foreground-700 hover:border-foreground-400 transition-colors cursor-pointer"
                  aria-label="上一条"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button
                  type="button"
                  onClick={handleNext}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="下一条"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>

            <div className="flex items-center gap-2 mt-8">
              {reviews.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => setActiveIndex(i)}
                  className={`w-8 h-1 rounded-full transition-all cursor-pointer ${
                    i === activeIndex ? 'bg-foreground-950 w-12' : 'bg-foreground-300'
                  }`}
                  aria-label={`评价 ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}